/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AmsBookingStatus = {
    Succeeded: 'Succeeded',
    Failed: 'Failed',
    Pending: 'Pending'
} as const;
export type AmsBookingStatus = typeof AmsBookingStatus[keyof typeof AmsBookingStatus];


export function instanceOfAmsBookingStatus(value: any): boolean {
    for (const key in AmsBookingStatus) {
        if (Object.prototype.hasOwnProperty.call(AmsBookingStatus, key)) {
            if (AmsBookingStatus[key as keyof typeof AmsBookingStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AmsBookingStatusFromJSON(json: any): AmsBookingStatus {
    return AmsBookingStatusFromJSONTyped(json, false);
}

export function AmsBookingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AmsBookingStatus {
    return json as AmsBookingStatus;
}

export function AmsBookingStatusToJSON(value?: AmsBookingStatus | null): any {
    return value as any;
}

export function AmsBookingStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AmsBookingStatus {
    return value as AmsBookingStatus;
}

